import React from "react";
import "../App.scss";
import AclApi from "../api/AclApi";
import LeftMenu from "./LeftMenu";

class If extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const render = this.props.value;
    if (render) {
      return (
        <>
          {this.props.children}
        </>
        );
    }

    return (
      null
    );
  }
}

export default If;
